import { Component } from "react";
import { connect } from "react-redux";
import { signOut } from "../../user/actions";
import { push } from "react-router-redux";

export class LogoutScreen extends Component {
  constructor(props) {
    super(props);

    this.signOut = this.signOut.bind(this);
  }

  componentDidMount() {
    this.props.signOut();
    this.props.redirectToLogin();
  }

  signOut() {
    this.props.redirectToLogin();
  }

  render() {
    return null;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
    redirectToLogin: () => dispatch(push('/login')),
  };
};


export default connect(null, mapDispatchToProps)(LogoutScreen);



// WEBPACK FOOTER //
// ./src/features/home/containers/LogoutScreen.js